
// region JS Imports

// region External Modules
import $ from "jquery"
import "bootstrap-modal"
import "bootstrap-modalmanager"
import _propertyOf from "lodash/propertyOf"
// endregion External Modules

// Private Modules
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports

const SELECTOR = ".js-link-modal"
// # Switch for using no wrapper
const NO_WRAPPER_CLASS = "js-link-modal-no-wrapper"

const onLoad = () => {
  const $body = $("body")

  $body.on("click", SELECTOR, (e) =>{
    e.preventDefault()

    const $link = $(e.currentTarget)
    const url_or_selector = $link.attr("href")
    const noWrapper = $link.hasClass(NO_WRAPPER_CLASS)

    $body.modalmanager("loading")

    // # if starts with "#" or ".", assumed selector
    if ( _propertyOf(url_or_selector)(0) === "#"  || _propertyOf(url_or_selector)(0) === "." ){
      Promise.resolve(
        import("app/modal/show-modal")
      )
      .then(({default: Modal}) => {
        Modal.showModalWithSelector(url_or_selector, {customContent: noWrapper})
      })
    }
    else{
      q_ajax_3({
        url:      url_or_selector,
        method:   "GET",
        dataType: "html",
      })
      .then(({data}) =>
        Promise.resolve(
          import("app/modal/show-modal")
        )
        .then(({default: Modal}) => {
          Modal.showModalWithContent(data, {customContent: noWrapper})
        })
      )
      .done()
    }
  })
}

export default {onLoad}
